module.exports = __webpack_public_path__ + "img/l5.e6a29f8b.png";